module.exports = require("core-js-pure/stable/set");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/set.js
// module id = 260
// module chunks = 0 1